export default __webpack_public_path__ + "static/media/HARYANA-11.b2a91b4a.webp";